import {ArenaGameFiltersCategoryBase} from "./arena-game-filters-category-base";
import {computed} from "mobx";
import {DynamicArenaGameFilter} from "../filters/dynamic-arena-game-filter";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {IGameFilterDefinition} from "../../filters-definitions/game-filter-definition.interface";


export class DynamicArenaGameFiltersCategory extends ArenaGameFiltersCategoryBase {

    protected _createArenaGameFilter(filterDefinition: IGameFilterDefinition): DynamicArenaGameFilter {
        return new DynamicArenaGameFilter(filterDefinition, this.services);
    }

    /**
     * Restrict available filters to only those that have applicable games in the current arena
     */
    @computed
    get availableFilters(): DynamicArenaGameFilter[] {
        if(this.categoryDefinition.hasItsOwnFiltersOrder) {
            return this._getAvailableFilters();
        } else {
            return this._getAvailableFilters().sort((f1, f2) => f2.gamesCount - f1.gamesCount);
        }
    }

    protected _getAvailableFilters(): DynamicArenaGameFilter[]{
        return this.categoryDefinition.availableFilters
            .map(f =>  this._createArenaGameFilter(f))
            .filter(f => f.gamesCount > 0);
    }

    @computed
    get gamesCount(): NullableNumber {
        const uniqueGameTypes = new Set();
        this.availableFilters.forEach(f => {
            f.games.forEach(game => uniqueGameTypes.add(game.gameType))
        });
        return uniqueGameTypes.size;
    }

}